import { makeAutoObservable } from 'mobx';
import axios from 'axios';
import { AvProxyApi } from '@availity/api-axios';
import CommonStore from '../CommonStore';

class IncidentStore {
  confirmationId = '';

  retryCount = 0;

  openErrorModal = false;

  openConfirmationModal = false;

  publicPostUrl = '/flriskmangmntreport/public/provconn/providers/submitrmir';

  constructor() {
    makeAutoObservable(this);
  }

  setOpenErrorModal() {
    this.openErrorModal = !this.openErrorModal;
  }

  setOpenConfirmationModal() {
    this.openConfirmationModal = !this.openConfirmationModal;
  }

  submitIncident = async (incidentForm) => {
    const { inPublicfacingFlow, handleChangeCommonStore, brand, config } = CommonStore;
    const stateCode = brand?.state?.code || brand?.state;
    const isOhMyCare = stateCode === 'OH' && /mycare/i.test(config?.templateName || '');
    handleChangeCommonStore('blocking', true);
    
    // Add requestType for WI market and OH MyCare flow (both use same submitrmir API but with requestType field)
  
    const payload = stateCode === 'WI' || isOhMyCare
      ? { ...incidentForm, requestType: 'Incident' }
      : { ...incidentForm };
    
    try {
      // All markets use the same submitrmir API
      const response = inPublicfacingFlow
        ? await axios.post(this.publicPostUrl, payload)
        : await new AvProxyApi({ tenant: 'anthem', name: 'provconn/v1/providers/submit' }).post(payload);

      handleChangeCommonStore('blocking', false);
      if (response && response.status === 200) {
        if (response.data.pyID) {
          this.confirmationId = response.data.pyID;
          this.retryCount = 0;
          this.setOpenConfirmationModal();
        } else {
          this.retryCount += 1;
          this.setOpenErrorModal();
        }
      } else {
        this.retryCount += 1;
        handleChangeCommonStore('blocking', false);
        this.setOpenErrorModal();
      }
    } catch {
      this.retryCount += 1;
      handleChangeCommonStore('blocking', false);
      this.setOpenErrorModal();
    }
  };

  handleChangeIncidentStore = (key, value) => {
    if (!key && !value) {
      return;
    }
    this[key] = value;
  };
}

export default new IncidentStore();
